<template>
	<div id="planindex">
        <HrrBreadcrumb PMname="岗位计划管理" CMname="岗位计划申报管理" />
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="searchform">
                    <el-form-item >
                        <el-input v-model="keyword" placeholder="关键字" >
                            <el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
                                <el-option label="计划名称" value="planName"></el-option>
                                <el-option label="计划描述" value="planDesc"></el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick()">新增</el-button>
                    <el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick()">编辑</el-button>
                    <el-button type="primary" icon="el-icon-delete" size="small" @click="delclick()">删除</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="tableData" ref="plantable"
                border 
                stripe 
                highlight-current-row 
                v-loading="loading"
                style="width: 100%" @cell-click="cellclick" @selection-change="selectionchange">
                    <el-table-column type="selection" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column prop="planName" label="计划名称" width="220" fixed="left">
                    </el-table-column>
                    <el-table-column prop="planDesc" label="计划描述" width="250">
                    </el-table-column>
                    <el-table-column prop="planStartdate" label="计划起始时间" width="180">
                        <template slot-scope="scope">
                            <span>{{scope.row.planStartdate| moment("YYYY-MM-DD")}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="planEnddate" label="计划终止时间" width="180">
                        <template slot-scope="scope">
                            <span>{{scope.row.planEnddate| moment("YYYY-MM-DD")}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="targetTotalnum" label="指标数" width="180">
                    </el-table-column>
                    <el-table-column prop="creationDate" label="创建时间" width="180">
                    </el-table-column>
                    <el-table-column prop="creationBy" label="创建人" width="180">
                    </el-table-column>
                    <el-table-column prop="statusName" label="状态" width="120" fixed="right">
                    </el-table-column>
                    <el-table-column label="操作" width="120" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="Rowview(scope.row)" type="text" size="small">查看</el-button>
                            <el-button @click.stop="RowEdit(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click.stop="Rowdelete(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
        </HrrMainLayout>
	</div>
</template>
<script>
    export default {
        name: 'plan_index',
        data() {
            return {
                searchform: {
                    pageNum: 1,
                    pageSize: 10,
                    planName: "",
                    planDesc:""
                },
                tableData: [],
                total: 0,
                loading: true,
                selectionRows:[],
                selectfield:"planName",
                keyword:"",
                statusData:[]
            }
        },
        methods: {
            onSubmit() {
                this.searchform.planName="";
                this.searchform.planDesc="";
                this.searchform[this.selectfield]=this.keyword;
                this.initData();
            },
            handleSizeChange(val) {
				this.searchform.pageSize=val;
				this.initData();
			},
			handleCurrentChange(val) {
				this.searchform.pageNum=val;
				this.initData();
			},
            Rowview(val) {
                const planid = val.planId;
                this.$route.meta.row = val;
                this.$common.SetSessionRow("row",val);
                this.$router.push({
                    path: '/plan/index/view/' + planid
                });
            },
            RowEdit(val) {
                const planid = val.planId;
                this.$route.meta.row = val;
                this.$common.SetSessionRow("row",val);
                this.$router.push({
                    path: '/plan/index/edit/' + planid
                });
            },
            Rowdelete(val){
				this.$confirm("确定要删除 '"+val.planName+"' 此记录么？","删除提示",{type:"warning"})
				.then(()=>{
					var Vuethis=this;
					this.$hrraxios.post(this.$api.plan.planDel,{planId:val.planId})
					.then((response)=>{
						var redata=response.data;
						if(redata.success==true){
							Vuethis.$message({message:"删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							Vuethis.$message({message:redata.prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
			},
            Addclick() {
                this.$router.push({
                    path: '/plan/index/add/',
                });
            },
            editclick(){
				if(this.selectionRows.length==0)
				{
					this.$message.warning("请先选择一行记录");
					return;
				}
				if(this.selectionRows.length>1)
				{
					this.$message.warning("只能操作一行记录");
					return;
				}
				this.$route.meta.row=this.selectionRows[0];
                this.$common.SetSessionRow("row",this.selectionRows[0]);
				this.$router.push({path:'/plan/index/edit/'+this.selectionRows[0].planId});
			},
            delclick(){
				if(this.selectionRows.length<1)
                {
                    this.$message({message:"请先选择一行在删除",type:"warning"});
                    return;
                }
                this.$confirm("确定要删除这些记录么？",{type:"warning"})
                .then(()=>{
                    var loading = this.$loading({
                        lock: true,
                        text: '删除中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis=this;
                    var PostfunArr=[];
                    this.selectionRows.forEach(myrow=>{
                        var postRe=this.$hrraxios.post(this.$api.plan.planDel,{planId:myrow.planId});
                        PostfunArr.push(postRe);
                    });
                    this.$axios.all(PostfunArr)
                    .then(this.$axios.spread(function(){
                        loading.close();
                        //console.log(arguments);
                        var isalldel=true;
                        for(var i=0;i<arguments.length;i++){
                            if(arguments[i].data.success==false)
                            {
                                isalldel=false;
                            }
                        }
                        if(isalldel==true){
                            Vuethis.$message({message:"全部删除成功！",type:"success"});
                            Vuethis.initData();
                        }else{
                            //有删除失败的未处理
                        }
                    }));
                })
                .catch((error)=>{
                    
                });
			},
			cellclick(row, column, cell, event){
				this.$refs.plantable.toggleRowSelection(row);
			},
			selectionchange(selection){
				this.selectionRows=selection;
			},
            initPlanData() {
                var Vuethis = this;
                this.loading = true;
                this.$hrraxios.get(this.$api.plan.getPagePlanList, {params: this.searchform})
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.success == true) {
                        Vuethis.tableData = data.data.list;
                        Vuethis.total = data.data.total;
                        Vuethis.tableData.forEach((e)=>{
                            e.statusName=Vuethis.statusData.find((s)=>{return s.statusValue==e.status;}).statusName;
                        });
                    } else {
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
            },
            initData(){
                this.$common.getStatus({forTable:"hrr_plan"},"statusData",this,this.initPlanData);
            }
        },
        beforeRouteLeave(to, from, next) {
            // 导航离开该组件的对应路由时调用
            to.meta.row = from.meta.row;
            next();
        },
        created() {
            this.initData();
        }
    }
</script>
